// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Despesas_BaixarDespesaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /despesas/baixar_despesa/{despesa_id}
 *
 * Returns a success message after marking a despesa as paid (status = 2).
 * The `dados` field is a string message, preserved from the legacy
 * primitive-dados shape via a custom getDados() override.
 *
 * Failure paths use $this->sendError('...') in the controller; no
 * ResponseContract is needed for errors.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Despesas_BaixarDespesaResponseDados = string;

export type Despesas_BaixarDespesaResponse = ApiResponse<Despesas_BaixarDespesaResponseDados>;

registerResponseContract('Despesas_BaixarDespesaResponse', {})
